import { Link, isRouteErrorResponse, useRouteError } from "react-router";
import { Notice } from "../design/components";

export function ErrorBoundary() {
  const error = useRouteError();
  let message = "Something went wrong while rendering this screen.";
  if (isRouteErrorResponse(error)) message = `${error.status} ${error.statusText}`;
  // a raw message is developer detail; production shows the generic line only
  else if (import.meta.env.DEV && error instanceof Error) message = error.message;

  return (
    <Notice kind="fail">
      <p>{message}</p>
      <Link to="/">Back to the dashboard</Link>
    </Notice>
  );
}
